import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';

// 初始化cube jView的样式
export function initCubeDomStyle(cube: CubeNode): void {
    let parentCube: CubeNode = CubeTree.findParentCubeByCubeId(cube.id);
    let style: FreeObjMap = {
        top: '',
        bottom: UIToolkit.getPXSizeValue(cube.id, 'posY') || 0,
        left: UIToolkit.getPXSizeValue(cube.id, 'posX') || 0,
        position: 'absolute'
    };

    if (CubeTree.isBeam(parentCube.id)) {
        let layerHeight: number = UIToolkit.getPXSizeValue(parentCube.id, 'moduleHeight');

        style.bottom = '';
        style.top = `-${layerHeight}px`;
    }

    cube.jView.css(style);
}
